import { IconButton, TextField } from "@material-ui/core";
import styled, { keyframes } from 'styled-components';
import { DEVICE } from '../../GlobalStyle';

export const Content = styled.div`
  width: 250px;
  padding: 0 20px 20px 20px;
  background-color: white;
  border-radius: 20px;
`;

export const Input = styled(TextField)`
  && {
    margin-top: 10px;
  }
  && .inputRoot {
    font-weight: 300;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SubmitButton = styled.button`
  margin-top: 15px;
  height: 35px;
  outline: none;
  cursor: pointer;
  border: unset;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledIconButton = styled(IconButton)`
  && {
    padding: unset;
    :hover {
      background-color: unset;
    }
  }
  svg {
    width: 0.8em;
  }
`;

export const Title = styled.p`
  font-size: 14px;
  margin: 1em 0 15px 0;
`;

export const OtherAuth = styled.p`
  margin: 1em 0 1em 0;
  font-size: 13px;
  text-overflow: clip;
  width: 240px;
  text-align: center;
  a {
    text-decoration: none;
    :hover {
      text-decoration: underline;
    }
  }
`;


export const Container = styled.div<{ primary?: string, secondary?: string, text?: string, isExpanded: boolean }>`
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media ${DEVICE.mobile} {
    height: calc(100vh - 50px);
    height: calc(100 * var(--vh) - 50px);
  }

  ${props => props.isExpanded ? `
    height: calc(100vh - 50px);
    height: calc(100 * var(--vh) - 50px);
  `
    :
    ``
  }

  ${SubmitButton} {
    background-color: ${props => props.primary}; 
    color: ${props => props.secondary}; 
  }

  ${Input} {
    & .focusedLabel {
    color: ${props => props.primary};
    }
    & .MuiInput-underline:after {
      border-bottom: 2px solid ${props => props.primary};
    }
    & .MuiInput-underline:hover::before {
      border-bottom: 2px solid ${props => props.primary};
    }
  }

  ${Content} {
    box-shadow: 0 3px 10px 0 rgba(0,0,0,.08), 0 0 1px 0 rgba(0,0,0,.22), inset 0 2px 0 0 ${props => props.primary};
  }

  ${Title} {
    color: ${props => props.text};
  }

  ${OtherAuth} {
    color: ${props => props.text};
  }
`;

export const FormError = styled.p`
  font-size: 14px;
  color: red;
  margin-top: 6px;
  margin-bottom: -4px;
  text-align: center;
`;

const rotation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }`;

export const Loading = styled.div`
  :after {
    content: " ";
    display: block;
    width: 14px;
    height: 14px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: ${rotation} 1.2s linear infinite;
  }
`;

export const AuthError = styled.span`
  text-align: center;
`;